import type { NSchedule } from '@app/types/Schedule';

export const handleAddingScheduleId = (
  Id: NSchedule.ModelWorkSchedule['Id'],
  isReverse = false
) => {
  if (isReverse) {
    if (Id === 0) {
      return Id;
    } else {
      return 0;
    }
  } else {
    if (Id > 999999999) {
      return 0;
    } else {
      return Id;
    }
  }
};
